import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationComponent } from '../../app/shared';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private snackBar = inject(MatSnackBar);

  notify(type: 'error' | 'success', message: string, icon: string, duration = 5000): void {
    this.snackBar.openFromComponent(NotificationComponent, {
      duration,
      horizontalPosition: 'end',
      data: { message, icon, type },
    });
  }
}
